import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/node_modules/@mui/icons-material/esm/Telegram.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/node_modules/@mui/icons-material/esm/X.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/node_modules/@mui/material/SvgIcon/SvgIcon.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/src/app/_components/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dashboard"] */ "/home/runner/work/play/play/src/components/Dashboard/Dashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BREAKPOINTS"] */ "/home/runner/work/play/play/src/components/ui-kit/hooks/screenSizeHooks.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ConnectionProvider"] */ "/home/runner/work/play/play/src/hooks/connection.tsx");
